import { faFileInvoice, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBContainer,
  MDBRow,
} from "mdbreact";
import React from "react";

const PrintPayment = (props) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  function generateString(length) {
    let result = " ";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  const id = generateString(15);
  const ds = generateString(8);
  return (
    <React.Fragment>
      <MDBCardHeader className="cloudy-knoxville-gradient">
        <MDBRow>
          <MDBCol md="8">
            {" "}
            <span
              className="h5-responsive blue-text"
              style={{
                fontFamily: "Montserrat",
                fontWeight: "400",
              }}
            >
              <span className="blue-text">
                <FontAwesomeIcon icon={faPrint} />
              </span>
              &nbsp;Acknowledgement Receipt
            </span>
          </MDBCol>
          <MDBCol md="4" className="text-right">
            <a
              href={
                props.apiServerHybrid +
                "MPrint/ORPrint?reporttype=payment&code=" +
                props.parentcode +
                "&uc=" +
                sessionStorage.getItem("msal.uc") +
                "&preview=" +
                id +
                "&ds=" +
                ds +
                "&slc=" +
                props.code
              }
              target="_blank"
              className="brown-text font-weight-bold"
              title="Print in New Window"
            >
              <FontAwesomeIcon icon={faPrint}> </FontAwesomeIcon>&nbsp;Print in
              New Window
            </a>
          </MDBCol>
        </MDBRow>
      </MDBCardHeader>
      <MDBCardBody>
        <div
          className="embed-responsive embed-responsive-21by9"
          style={{ minHeight: "1200px" }}
        >
          <iframe
            className="embed-responsive-item"
            src={
              props.apiServerHybrid +
              "MPrint/ORPrint?reporttype=payment&code=" +
              props.parentcode +
              "&uc=" +
              sessionStorage.getItem("msal.uc") +
              "&preview=" +
              id +
              "&ds=" +
              ds +
              "&slc=" +
              props.code
            }

            //   allowfullscreen
          ></iframe>
        </div>
      </MDBCardBody>
    </React.Fragment>
  );
};

export default PrintPayment;
